export default {
    encoding: [
        {
            name: 'value',
            type: '[number]',
            desc: 'Specify the dataSource applied to a pie chart.',
            defaultValue: 'primary[1]',
            isRequired: 'true',
        },
        {
            name: 'label',
            type: '[string]',
            desc: 'Specify the dataSource applied to a pie chart label.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
    ],
    events: [
        {
            name: 'point.click',
            desc: 'trigger when user clicks a data point',
        },
    ],
};
